import { RouteConfig } from "vue-router";
const MileageCalculator = () => import("@/views/mileage/mileage-calculator.vue");
const MileageHistory = () => import("@/views/mileage/mileage-history.vue");
const ManageClients = () => import("@/views/admin/manage-clients.vue");

export const mileageRoutes: RouteConfig[] = [
    {
        name: "Mileage Calculator",
        path: "/mileage/calculate",
        component: MileageCalculator
    },
    {
        name: "Mileage History",
        path: "/mileage/history",
        component: MileageHistory
    },
    {
        name: "Manage Clients",
        path: "/manage/clients",
        component: ManageClients
    }
];
